import { React, classNames, withStyles, StyledProps, CentricTheme, _, Fragment } from '@api'
import { Typography }                                               from '@material-ui/core'
import { FileUploadIcon, ImagePlaceholder, CardSizeType }                       from 'centric-ui-components'
import { observer } from 'mobx-react';
import { SecondaryButton, LazyAvatar }                                          from './'
import * as css from './Placeholder.css'


const styles = (theme: CentricTheme) => ({
  xlarge_placeHolder: {
    backgroundColor: '#f5f5f5',
    borderBottom: '1px solid #dedede',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    flexDirection: 'column',
    // width: 250,
    height: 250
  },
  large_placeHolder: {
    backgroundColor: '#f5f5f5',
    borderBottom: '1px solid #dedede',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    flexDirection: 'column',
    width: 250,
    height: 250
  },
  xlarge_placeHolder_disableUpload: {
    backgroundColor: '#f5f5f5',
    borderBottom: '1px solid #dedede',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    width: 300,
    height: 300
  },
  large_placeHolder_disableUpload: {
    backgroundColor: '#f5f5f5',
    borderBottom: '1px solid #dedede',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    width: 300,
    height: 300
  },
  selected: {
    backgroundColor: 'transparent'
  },
  medium_placeHolder: {
    backgroundColor: '#f5f5f5',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 160,
    height: 160,
    borderRadius: 2,
    borderBottom: '1px solid #dedede'
  },
  small_placeHolderSelected: {
    backgroundColor: '#f5f5f5',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 48,
    height: 48,
    opacity: 0.5
  },
  small_placeHolder: {
    backgroundColor: '#f5f5f5',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minWidth: 48,
    height: 48,
    borderRadius: 2,
    margin: `0 ${theme.spacing()}`
  },
  mini_placeHolder: {
    backgroundColor: '#f5f5f5',
    display:         'flex',
    justifyContent:  'center',
    alignItems:      'center',
    minWidth:        18,
    height:          18,
    borderRadius:    2,
    margin:          `0 ${theme.spacing()}`
  },
  small_icon: {
    width: 20,
    height: 20,
    color: '#6d6d6d',
    opacity: 0.5,
    backgroundColor: '#f5f5f5'
  },
  carousel: {
    marginTop: theme.spacing(),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },

  inactiveWrapper: {
    position: 'relative'
  },
  xlarge_inactiveIcon: {
    height: 300,
    position: 'absolute',
    transform: 'rotate(45deg)',
    left: '50%',
    top: '-25px',
    borderLeft: '2px solid red',
    zIndex: 1,
    pointerEvents: 'none'
  },
  large_inactiveIcon: {
    height: 300,
    position: 'absolute',
    transform: 'rotate(45deg)',
    left: '50%',
    top: '-25px',
    borderLeft: '2px solid red',
    zIndex: 1,
    pointerEvents: 'none'
  },
  medium_inactiveIcon: {
    height: 180,
    width: 180,
    position: 'absolute',
    transform: 'rotate(45deg)',
    left: '33%',
    top: 55,
    borderLeft: '2px solid red',
    zIndex: 999,
    pointerEvents: 'none'
  },
  noImage: {
    fontSize: 12,
    fontWeight: 300,
    color: '#9d9d9d'
  }
})

interface MyProps extends StyledProps {
  id?: string
  isActive?: boolean
  showIcon?: boolean
  isSelected?: boolean
  onClickPlaceholder?: (e) => void
  onDragEnter?: (e, id) => void
  onDragLeave?: (e, id) => void
  onDragOver?: (e, id) => void
  onDrop?: (e, id) => void
  onClickUploadImages?: (e) => void
  type?: CardSizeType,
  isCarousel?: boolean
  disableUpload?: boolean

  /** Todo:  !!!These are ignored!!! **/
  width?: number
  height?: number

  noImageText?: string
  avatar?: string

  extra?: React.ReactNode
}

@(withStyles as any)(styles)
@observer
export class Placeholder extends React.Component<MyProps> {
  static defaultProps = {
    noImageText: 'No Image'
  }

  render () {
    const {
      props: {
        className, id, isActive, showIcon, type, classes, isSelected, onDragEnter,
        onDragLeave, isCarousel, onClickPlaceholder, onDrop, onClickUploadImages,
        disableUpload, noImageText, avatar, extra
      }
    } = this

    return (
      <Fragment>
        <div key={`inactive-text-${id}`} className={classes.inactiveWrapper}>
          {!isActive && showIcon &&
          <div id={'inactive-svg'} className={classes[`${type}_inactiveIcon`]}/>}
        </div>

        <div key={`placeholder-img-${id}`}
             onDragEnter={e => {onDragEnter ? onDragEnter(e, id) : null }}
             onDragOver={e => {onDragEnter ? onDragEnter(e, id) : null}}
             onDragLeave={e => {onDragLeave ? onDragLeave(e, id) : null}}
             onDrop={e => {onDrop ? onDrop(e, id) : null}}
             onClick={onClickPlaceholder}
             draggable={false}
             data-type='placeholder'
             className={classNames(className, css.root, classes[`${type}_placeHolder${disableUpload ? '_disableUpload' : ''}`], {[classes.selected]: isSelected, 'inactive': !isActive })}
        >
          {extra}
          {/* <ImagePlaceholder type={type} /> */}
          {(disableUpload || !isCarousel) && type != 'mini' && !avatar && <Typography variant={'body1'} className={classes.noImage}>{noImageText}</Typography>}
          {(disableUpload || !isCarousel) && type != 'mini' && avatar && <LazyAvatar
              classes={{img: css.image}}
              lazy={false}
              className={classNames(css.secondaryImage, css.cover)}
              src={''}
            >{(_.capitalize(avatar) || '')}</LazyAvatar>}
          {!disableUpload && isCarousel && <div className={classes.carousel}>
            <Typography variant={'body1'} className={css.body2}>{type != 'mini' ? 'Drag Image Here' : 'X'}</Typography>
            <Typography variant={'body1'} className={css.body2}>or</Typography>
            <SecondaryButton icon={{position: 'left', component: <FileUploadIcon type=''/>}} onClick={onClickUploadImages}>Upload Image</SecondaryButton>
          </div>}
        </div>
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/ui/components/Placeholder.tsx